import React from 'react';
import { Award, Shield, Bot, ShieldCheck, Zap, Settings } from 'lucide-react';
import { mockData } from '../mock/consultingData';

const iconMap = {
  Award: Award,
  Shield: Shield,
  Bot: Bot,
  ShieldCheck: ShieldCheck,
  Zap: Zap,
  Settings: Settings
};

const CredibilityBar = () => {
  return (
    <section className="dark-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-4">Trusted <span className="turquoise-text">Certifications</span> & Expertise</h2>
          <p className="body-large text-gray-300 max-w-2xl mx-auto">
            Industry-recognized certifications demonstrating expertise in Quality Management, ISO Standards, and emerging technologies.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Left side - Certifications Image - Now visible on all screens */}
          <div className="lg:col-span-3 flex items-start max-h-[300px] md:max-h-[400px] lg:max-h-none overflow-hidden">
            <div className="relative group w-full lg:sticky lg:top-8">
              <img 
                src="/certifications-new.png"
                alt="Trusted Certifications and Expertise"
                className="w-full h-auto object-cover rounded-xl transform group-hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>

          {/* Right side - All 6 Cards in Grid (3x2) */}
          <div className="lg:col-span-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {mockData.certifications.map((cert, index) => {
              const IconComponent = iconMap[cert.icon];
              return (
                <div 
                  key={index} 
                  className="dark-card text-center group hover:border-turquoise-500 transition-all duration-300 hover:shadow-lg hover:shadow-turquoise-500/20"
                >
                  <div className="icon-container mx-auto mb-3 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent size={32} />
                  </div>
                  
                  <h3 className="text-base font-semibold mb-2 turquoise-text">{cert.name}</h3>
                  <p className="text-xs text-gray-400 mb-3">{cert.description}</p>
                  
                  <div className="bg-turquoise-500/10 border border-turquoise-500/30 rounded-none px-3 py-1.5 group-hover:bg-turquoise-500/20 transition-colors duration-300">
                    <span className="text-xs turquoise-text font-medium">Certified Expert</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        
        {/* Stats Section */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div className="p-6">
            <div className="display-medium turquoise-text mb-2">50+</div>
            <div className="body-medium text-gray-300">ISO Audits Completed</div>
          </div>
          <div className="p-6">
            <div className="display-medium turquoise-text mb-2">21+</div>
            <div className="body-medium text-gray-300">Years Experience</div>
          </div>
          <div className="p-6">
            <div className="display-medium turquoise-text mb-2">100%</div>
            <div className="body-medium text-gray-300">Compliance Rate</div>
          </div>
          <div className="p-6">
            <div className="display-medium turquoise-text mb-2">9</div>
            <div className="body-medium text-gray-300">Organizations Served</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CredibilityBar;